import styled from "styled-components";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100vw;
  min-height: calc(100vh - 90px - 40px);

  @media (min-width: 768px) {
    min-height: calc(100vh - 140px - 40px);
  }
`;

export default Container;
